import { render, staticRenderFns } from "./SimpleListAirportPopularRoutes.vue?vue&type=template&id=e708e612&"
import script from "./SimpleListAirportPopularRoutes.vue?vue&type=script&lang=js&"
export * from "./SimpleListAirportPopularRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports